//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Fingerprint2 from 'fingerprintjs2'
// import riskModule from '~/components/common/riskModule.vue'
import wikiHead from '~/components/common/head.vue'
import wikiFoot from '~/components/common/foot.vue'
export default {
  components: {
    // 'risk-module': riskModule,
    'wiki-head': wikiHead,
    'wiki-foot': wikiFoot
  },
  data () {
    const isHome = ['lang', 'lang-data-tradingquotes.html'].includes(
      this.$route?.name
    )
    return {
      isHome // 当前页面是否为首页
    }
  },
  head () {
    const { lang = '' } = this.$route.params
    const direction = !['ar', 'ur'].includes(lang) ? {} : { dir: 'rtl', class: 'opposite' }
    console.log(this?.$store?.state?.myCountry, 'this?.$store?.state?.myCountry')
    const allga = this?.$store?.state?.myCountry != 'cn'
      ? {
          src: 'https://www.googletagmanager.com/gtag/js?id=G-EH7WFXEEHY',
          body: false,
          async: true
        }
      : {}

    const scriptMap = {
      'wikifx.com': '/contentgj/eeeoeee.js',
      'wikifxact.com': '/contentgj/eeeoeee2.js',
      'fxeyetips.com': '/contentgj/eeeoeee3.js',
      'wikifx.vip': '/contentgj/eeeoeee4.js',
      'fxeye2017.com': '/contentgj/eeeoeee5.js',
      'wikifx2.com': '/contentgj/eeeoeee6.js',
      'shareowen.com': '/contentgj/eeeoeee7.js',
      'mchgi.com': '/contentgj/eeeoeee8.js',
      'wikifx25.com': '/contentgj/eeeoeee9.js',
      'fxeye25.com': '/contentgj/eeeoeee10.js',
      'fxeyema.com': '/contentgj/eeeoeee11.js',
      'fxeyecn.com': '/contentgj/eeeoeee12.js',
      'wikifxvn.com': '/contentgj/eeeoeee13.js',
      'wikifxvi.com': '/contentgj/eeeoeee14.js',
      'wikifxen.com': '/contentgj/eeeoeee15.js',
      'wikifxzh.com': '/contentgj/eeeoeee16.js',
      'wikifxka.com': '/contentgj/eeeoeee17.js',
      'wikifxcn.com': '/contentgj/eeeoeee18.js',
      'fxeye110.com': '/contentgj/eeeoeee19.js',
      'fxeye123.com': '/contentgj/eeeoeee20.js',
      'fxeye777.com': '/contentgj/eeeoeee21.js',
      'fxeye688.com': '/contentgj/eeeoeee22.js',
      'fxeye.com': '/contentgj/eeeoeee23.js',
      'fxeyevn.com': '/contentgj/eeeoeee24.js',
      'fxeyevi.com': '/contentgj/eeeoeee25.js',
      'fxeye555.com': '/contentgj/eeeoeee26.js',
      'fxeye2021.com': '/contentgj/eeeoeee27.js',
      'fxeyefx.com': '/contentgj/eeeoeee28.js',
      'fxeyevps.com': '/contentgj/eeeoeee29.js',
      'wikifx.hk': '/contentgj/eeeoeee30.js',
      'wikifxtips.com': '/contentgj/eeeoeee31.js',
      'fxeyevip.com': '/contentgj/eeeoeee33.js',
      'fxeyeka.com': '/contentgj/eeeoeee34.js'
    }
    const defaultScript = '/contentgj/eeeoeee.js'
    const eeeoeee = {}
    const chost = this.$store.state.fullHost
    console.log('chost::: ', chost)
    Object.assign(eeeoeee, {
      src:
        scriptMap[
          Object.keys(scriptMap).find(host => chost.includes(host))
        ] || defaultScript,
      body: false,
      async: true
    })

    const rptxt = {
      charset: 'utf-8',
      src: '/contentgj/rptxt.js',
      body: false,
      async: true
    }

    return {
      htmlAttrs: {
        lang,
        ...direction
      },
      link: this.setCanonical(),
      script: [eeeoeee, rptxt, allga]
    }
  },
  computed: {
    ...mapGetters(['cookConf'])
  },

  mounted () {
    if (!this.$cookies.get('wiki-bfp')) this.setBfp() // 浏览器指纹码
  },
  methods: {
    setBfp () {
      // 浏览器指纹码
      Fingerprint2.get((components) => {
        // 浏览器指纹码
        const values = components.map(function (component, index) {
          if (index == 0) {
            // 把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, '')
          }
          return component.value
        })
        // 生成最终id murmur
        const murmur = Fingerprint2.x64hash128(values.join(''), 31)
        console.log('murmur::: ', murmur)
        const now = new Date(
          new Date(new Date().getTime()).setFullYear(9998, 0, 0)
        )
        this.$cookies.set('wiki-bfp', murmur, {
          expires: now,
          path: '/',
          domain: this.cookConf
        })
        this.$store.commit('getbfp', murmur)
      })
    }
  }
}
